// config context to hold:
// - iari source
// - url status check method
import {createContext} from 'react';
export const ConfigContext = createContext({});
